<div
  class="flex justify-start content-center items-center flex-row gap-2.5"
  [attr.data-test-id]="`omnisearch-result-${omnisearchResponse.id}`"
>
  <app-omnisearch-icons
    class="basis-[35px]"
    [icon]="omnisearchResponse.entity"
    [matTooltip]="omnisearchResponse.entity | category | titlecase"
  >
  </app-omnisearch-icons>

  <div class="flex-1">
    <div class="title" data-test-id="omnisearch-result-name">
      @if (omnisearchResponse.entity === 'profiles') {
        <span [innerHTML]="omnisearchResponse.nameHighlight | safeHtml"></span>
      } @else {
        <span [innerHTML]="omnisearchResponse | omnisearchname | searchHighlight: searchTerm | safeHtml"></span>
      }
    </div>

    <div class="flex justify-start content-center items-center flex-row">
      @if (omnisearchResponse.entity === 'profiles') {
        <li class="geography" data-test-id="omnisearch-result-expert-geography">
          {{ omnisearchResponse.geographicTarget }}
        </li>
        <div
          class="email-address"
          data-test-id="omnisearch-result-expert-primary-email-address"
          [matTooltip]="omnisearchResponse.matchedEmail"
          [innerHTML]="omnisearchResponse.matchedEmailHighlight | safeHtml"
        ></div>
        @if (omnisearchResponse.matchedPhoneNumber) {
          <div
            class="email-address ml-6 shrink-0"
            data-test-id="omnisearch-result-expert-primary-phone-number"
            [matTooltip]="omnisearchResponse.matchedPhoneNumber"
            [innerHTML]="omnisearchResponse.matchedPhoneNumberHighlight | safeHtml"
          ></div>
        }
      }

      @if (omnisearchResponse.entity === 'solicitationExperts') {
        <li class="geography" data-test-id="omnisearch-result-expert-geography">
          {{ omnisearchResponse.geographicTarget }}
        </li>
        <div
          class="email-address"
          data-test-id="omnisearch-result-expert-primary-email-address"
          [innerHTML]="omnisearchResponse.emailAddress | searchHighlight: searchTerm | safeHtml"
        ></div>
        <ul class="expertise flex flex-row gap-[5px]">
          @for (email of omnisearchResponse.allEmails; track email) {
            <li data-test-id="omnisearch-result-expert-email-address">
              {{ email }}
            </li>
          }
        </ul>
      }

      @if (omnisearchResponse.entity === 'opportunities') {
        @if (users$ | async; as users) {
          <ul class="flex flex-row gap-[5px]">
            @for (user_id of omnisearchResponse.opportunityAssigneeIds; track user_id) {
              <li>
                <app-initials-avatar
                  data-test-id="omnisearch-result-opportunity-project-manager"
                  showTooltip
                  [firstName]="users[user_id]?.first_name"
                  [lastName]="users[user_id]?.last_name"
                />
              </li>
            }
          </ul>
        }
      }
    </div>
  </div>

  <div class="flex flex-row justify-end content-center items-center h-full gap-5">
    @if (omnisearchResponse.entity === 'opportunities') {
      <a
        mat-icon-button
        class="action-button"
        [matTooltip]="omnisearchResponse.entity | detailsTooltip"
        [routerLink]="omnisearchResponse | omnisearchUrl: 'dashboard'"
      >
        <mat-icon data-test-id="omnisearch-result-view-details">subject_rounded</mat-icon>
      </a>
    }
    <a
      matMiniFab
      class="action-button"
      [matTooltip]="omnisearchResponse.entity | urlTooltip"
      [routerLink]="omnisearchResponse | omnisearchUrl"
    >
      <mat-icon data-test-id="omnisearch-result-go-to-item">arrow_forward</mat-icon>
    </a>
  </div>
</div>
